import getIn from 'transmute/getIn';
export const getUser = getIn(['auth', 'user']);